// Auto-generated by scripts/generate-registry.mjs from packages/modules/core_badge_plate/ui-config.json — DO NOT EDIT MANUALLY!
import type { ModuleSchema } from './types.js';

export const core_badge_plate: ModuleSchema = {
  "id": "core_badge_plate",
  "uniqueId": "B3D_JAP5S",
  "createdAt": "2026-10-11T05:00:00Z",
  "updatedAt": "2026-10-28T14:57:47.733Z",
  "label": "Badge Plate",
  "description": "Standalone core geometry module for badge plate with rounded rim (CG_BDG01)",
  "category": "core_geometry",
  "tags": [
    "core-geometry",
    "CG_BDG01",
    "badge-plate",
    "rim"
  ],
  "sliders": [
    {
      "key": "diameter",
      "label": "Badge Diameter (mm)",
      "min": 25,
      "max": 80,
      "default": 45,
      "step": 1,
      "unit": "mm",
      "integerOnly": false,
      "enabled": true,
      "visible": true
    },
    {
      "key": "baseThickness",
      "label": "Base Plate Thickness (mm)",
      "min": 0.6,
      "max": 4,
      "default": 1,
      "step": 0.2,
      "unit": "mm",
      "integerOnly": false,
      "enabled": true,
      "visible": true
    },
    {
      "key": "rimThickness",
      "label": "Rim Thickness (mm)",
      "min": 1,
      "max": 6,
      "default": 2,
      "step": 0.2,
      "unit": "mm",
      "integerOnly": false,
      "enabled": true,
      "visible": true
    },
    {
      "key": "rimWidth",
      "label": "Rim Width (mm)",
      "min": 1,
      "max": 8,
      "default": 2,
      "step": 0.25,
      "unit": "mm",
      "integerOnly": false,
      "enabled": true,
      "visible": true
    },
    {
      "key": "edgeRound",
      "label": "Edge Fillet / Chamfer (mm)",
      "min": 0.1,
      "max": 2,
      "default": 0.5,
      "step": 0.1,
      "unit": "mm",
      "integerOnly": false,
      "enabled": true,
      "visible": true
    }
  ],
  "selects": [],
  "textParams": [],
  "colorConfigs": [
    {
      "key": "badge",
      "label": "Badge Plate Color",
      "default": "#ffffff",
      "enabled": true,
      "visible": true,
      "targetGroupIds": [
        0
      ]
    }
  ],
  "objects": [
    {
      "id": "badge_plate",
      "name": "Badge Plate Solid",
      "parts": [
        {
          "id": "badge_part",
          "name": "Plate with Rim",
          "groupId": 0,
          "previewQuality": "medium",
          "exportQuality": "high"
        }
      ]
    }
  ],
  "exportGroups": [
    {
      "id": "all",
      "label": "Download STL - Badge Plate"
    }
  ]
};
